import { render, staticRenderFns } from "./SelectSearch.vue?vue&type=template&id=1dc09034&"
import script from "./SelectSearch.vue?vue&type=script&lang=ts&"
export * from "./SelectSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports